<div class="overview">
	<div class="tasks">
		<div class="overview-header">
			<H2>{{ controller.docs.title }}</H2>				{{ controller.docs.description }}
		</div>
		<div>
			<div class="line-item">
				<a class="complete-all" (click)="completeAll()">Complete All</a>
			</div>
			@for (task of controller.docs.items; track task) {
				<div class="line-item">
					<div>{{ task.label }}</div>
					<div class="print-checkbox-container">
						<div class="print-icon"><button mat-icon-button><mat-icon>print</mat-icon></button></div>
						<div>
							<mat-checkbox [(ngModel)]="taskValues[controller.docs.id +'.'+task.id]"
						              (ngModelChange)="setValue(controller.docs.id,task.id,$event)"></mat-checkbox>
						</div>
					</div>
				</div>
			}
		</div>
	</div>
</div>
